export enum FormTypes {
  LOGIN_FORM = 'login',
  FORGOT_PASSWORD = 'forgotPassword',
  RESET_PASSWORD = 'resetPassword',
  MARKETING_MESSAGE_PAGE = 'marketingMessagePage',
  RESET_PASSWORD_SUCCESS = 'resetPasswordSuccess',
  SIGN_UP_FORM = 'signUp',
  WELCOME_PAGE = 'welcomePage',
  SUCCESS_PAGE = 'successPage',
  LAST = 'last',
  PERSONAL_AREA_PAGE = 'personalArea',
}
